import React from 'react'
import {
  IHeaderOptionsModuleFields,
  IVariationContainerFields,
} from 'contentful/types/contentful-modules'
import { useSpecificOptimizelyUserDecision } from 'src/lib/optimizely/optimizely-for-client'

interface OptimizelyHeaderVariantContainerProps {
  variationContainerFields: IVariationContainerFields<IHeaderOptionsModuleFields>
  renderHeader: (
    headerOptions: IHeaderOptionsModuleFields,
  ) => React.ReactElement
}

export const OptimizelyHeaderVariantContainer: React.FC<
  OptimizelyHeaderVariantContainerProps
> = ({ variationContainerFields, renderHeader }) => {
  const { flagKey, meta, variations } = variationContainerFields
  const decision = useSpecificOptimizelyUserDecision(flagKey)

  if (!variations?.length) {
    return null
  }

  if (!decision?.enabled) {
    return null
  }

  const winningEntryContentfulId = meta?.[decision.variationKey]

  if (!winningEntryContentfulId) {
    return null
  }

  const winningEntry = variations.find(
    (v) => v.sys?.id === winningEntryContentfulId,
  )
  if (!winningEntry) {
    return null
  }

  return renderHeader(winningEntry.fields)
}
